import {createAction, props} from "@ngrx/store";
import {InfoListDto} from "@server-models";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {ILocalInfosMyReadDto} from "@tech/pages/infos/interfaces/infos-my-read-dto.interface";
import {ISharedLocalBodyRequest} from "@shared/interfaces/shared-local-body-request.interface";
import {ILocalRequestPayload} from "@shared/interfaces/local-request-payload.interface";

export const getInfoList = createAction(
  '[Infos-Tech] Get Info List',
  props<ILocalRequestPayload>()
);

export const getInfoListCancel = createAction(
  '[Infos-Tech] Get Info List Cancel',
);

export const getInfoListSuccess = createAction(
  '[Infos-Tech] Get Info List success',
  props<{ data: ILocalPageOutputDto<InfoListDto[]> }>()
);

export const getInfoListFail = createAction(
  '[Infos-Tech] Get Info List fail',
  props<{ error: any }>()
);

export const getInfoListRefresh = createAction(
  '[Infos-Tech] Get Info List Refresh',
  props<{ data: ILocalPageOutputDto<InfoListDto[]> }>()
);

export const postItemsMyRead = createAction(
  '[Infos-Tech] Post My Read',
  props<{ id: number }>()
);

export const postItemsMyReadSuccess = createAction(
  '[Infos-Tech] Post My Read Success',
  props<{ updatedItems: InfoListDto[], data: ILocalPageOutputDto<ILocalInfosMyReadDto> }>()
);

export const postItemsMyReadFail = createAction(
  '[Infos-Tech] Post My Read Fail',
  props<{ error: any }>()
);
